import React from "react";
import { styles } from "./About.styles";
const About = () => {
    return (<div style={styles.root}>
        <p>Designed and Developed by <a style={styles.content} href="https://sites.google.com/trimble.com/spime/home">Trimble Spime</a></p>
    </div>);
}
export default About;

